export const USER_GENDER = {
   MALE: 'MALE',
   FEMALE: 'FEMALE'
};

export const USER_GENDER_SERVER_TO_CLIENT_MAPPING = {
   MALE: 'Male',
   FEMALE: 'Female'
};
